import Cookies from 'js-cookie';
import { API_ADMIN_URL } from './services-variables';

// Never retain request configuration, credentials or response bodies in errors.
export class StaffRequestError extends Error {
  constructor(public status: number) {
    super(status === 401 ? 'Сессия завершена. Войдите снова.' : status === 403 ? 'Недостаточно прав или учётная запись отключена.' : status === 0 ? 'Нет соединения с сервером. Повторите действие вручную.' : status >= 500 ? 'Сервер временно недоступен. Повторите действие позже.' : status === 422 ? 'Проверьте параметры запроса.' : 'Не удалось выполнить действие.');
    this.name = 'StaffRequestError';
  }
}
export function staffErrorMessage(error: unknown): string {
  return error instanceof StaffRequestError ? error.message : 'Не удалось выполнить действие.';
}

export async function staffRequest<T = unknown>(path: string, method = 'GET', body?: unknown, authenticated = true): Promise<{ data: T; status: number }> {
  const base = new URL(API_ADMIN_URL);
  const url = new URL(path, base);
  if (url.origin !== base.origin || !url.pathname.startsWith('/api/admin_panel_router') || url.username || url.password || url.searchParams.has('token')) {
    throw new StaffRequestError(0);
  }
  if (typeof window === 'undefined') throw new StaffRequestError(401);
  const token = authenticated ? Cookies.get('admin-token') : undefined;
  if (authenticated && !token) throw new StaffRequestError(401);
  const headers: Record<string, string> = { Accept: 'application/json' };
  // Also supported by the legacy moderation dependency.
  if (token) headers['X-USER-TOKEN'] = token;
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  let response: Response;
  try {
    response = await fetch(url.href, { method, headers, body: body === undefined ? undefined : JSON.stringify(body), credentials: 'omit', cache: 'no-store', redirect: 'error' });
  } catch { throw new StaffRequestError(0); }
  if (!response.ok) throw new StaffRequestError(response.status);
  try { return { data: response.status === 204 ? undefined as T : await response.json() as T, status: response.status }; }
  catch { throw new StaffRequestError(502); }
}
